import React, { FC } from 'react';
import { ServiceDataMoment } from '../../Analytics/Service/AnalyticsServiceGrid';
import { OParagraph, OSmallParagraph } from '@lifechurch/react-ion';
import styled from 'styled-components';
import { ChopImage } from '@components/ChopImage';
import { useTranslation } from 'react-i18next';

interface Props {
  moment: ServiceDataMoment;
}

const StyledParagraph = styled(OSmallParagraph)`
  font-weight: bold;
`;

const StyledOParagraph = styled(OParagraph)`
  color: ${props => props.theme.colors.gray50};
`;

const ImageMomentDetail: FC<Props> = ({ moment }) => {
  const { t } = useTranslation('display_moment_details_modal');

  return (
    <>
      <ChopImage height={100} src={moment?.image?.url ?? ''} />
      <StyledParagraph marginBlockStart={5}>{t('alt_text')}</StyledParagraph>
      <OParagraph marginBlockStart={1}>{moment.image?.altText}</OParagraph>
      <StyledParagraph marginBlockStart={5}>{t('share_text')}</StyledParagraph>
      {moment.image?.shareText ? (
        <OParagraph marginBlockStart={1}>{moment.image?.shareText}</OParagraph>
      ) : (
        <StyledOParagraph marginBlockStart={1}>{t('na')}</StyledOParagraph>
      )}
    </>
  );
};

export default ImageMomentDetail;
